import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { useLocation } from 'react-router-dom';

export type TitlesDataSource = 'current' | 'newIngest';

const TitlesDataSourceContext = createContext<TitlesDataSource>('current');

const isNewIngestPath = (pathname: string) =>
  pathname === '/ingest/search' || pathname.startsWith('/ingest/search/');

export const TitlesDataSourceProvider: FC<PropsWithChildren> = ({ children }) => {
  const { pathname } = useLocation();
  const dataSource: TitlesDataSource = isNewIngestPath(pathname) ? 'newIngest' : 'current';

  return (
    <TitlesDataSourceContext.Provider value={dataSource}>
      {children}
    </TitlesDataSourceContext.Provider>
  );
};

const useTitlesDataSource = (): TitlesDataSource => useContext(TitlesDataSourceContext);

export const useIsNewIngest = () => useTitlesDataSource() === 'newIngest';

export default useTitlesDataSource;
